
import { Component, Prop,Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import { DateTime } from 'luxon'
import { EventData, EventExtendedProps } from '@/common-datatypes'

@Component

export default class ICalEventDetails extends Mixins(Common) {
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  exProps = {} as EventExtendedProps

  get description(){
    if(this.exProps.description){
      return this.$autoLink(this.$stripTags(this.exProps.description))
    }
    return ''
  }

   get dateTime(){
    if(! this.theEventData || ! this.theEventData.start || ! this.theEventData.end){
      return ''
    }

    const timeZone = this.theEventData.timeZone

    // start と end で日付が違うかどうか
    const start = DateTime.fromJSDate(this.theEventData.start).setZone(timeZone)
    const end = DateTime.fromJSDate(this.theEventData.end).setZone(timeZone)

    const isSameTime = (start == end ? true : false)

    const isSameday = start.startOf('day').diff(end.startOf('day')).milliseconds === 0 ? true : false

    const isAllDay = end.diff(start,'days').days % 1 === 0 ? true : false

    let dateTime = ''
 
    if(isSameTime){
      dateTime = this.$dateTimeFormat(start,'DDDD T (ZZZZ)',timeZone)
    }else if(isAllDay){
      dateTime = this.$dateTimeFormat(start,'DDDD',timeZone)
      if(! isSameday){
        dateTime += ' – ' + this.$dateTimeFormat(end,'DDDD(ZZZZ)',timeZone)
      }
    }else{
      dateTime = this.$dateTimeFormat(start,'DDDD T',timeZone) + ' – '
      if(isSameday){
        dateTime += this.$dateTimeFormat(end,'T (ZZZZ)',timeZone)
      }else{
        dateTime += this.$dateTimeFormat(end,'DDDD T (ZZZZ)',timeZone)
      }
    }

    return dateTime
  }
  
  async created(){
    //
  }

  mounted(){
    //
  }
}
